export type PageType = "index" | `${PostType}` | PostType;

export const useHelper = () => {
  const striptags = (text: string) => text.replace(/<[^>]+>/g, "");

  const nl2br = (text: string) => text.replace(/\n/g, "<br>");

  return { striptags, nl2br };
};
